module.exports = __webpack_public_path__ + "static/media/gift08_ja.30f23108.png";